var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrapper" }, [
      _c("div", { staticClass: "contacts" }, [
        _c("p", { staticStyle: { "margin-bottom": "10px" } }, [
          _c("strong", [_vm._v("LD power automation")])
        ]),
        _vm._v(" "),
        _c("p", [_vm._v("1379 W Park Western Dr #283")]),
        _vm._v(" "),
        _c("p", [_vm._v("San Pedro, CA 90732")]),
        _vm._v(" "),
        _c("p", [_vm._v("USA")]),
        _vm._v(" "),
        _c("hr"),
        _vm._v(" "),
        _c("p", [_vm._v("Tel: +1 310 7071115")]),
        _vm._v(" "),
        _c("p", [_vm._v("Fax: +1 310 6269486")]),
        _vm._v(" "),
        _c("p", [_vm._v("E-mail: info@ldpa.us")]),
        _vm._v(" "),
        _c("p", [
          _c("a", { attrs: { href: "www.ldpa.com" } }, [_vm._v("www.ldpa.com")])
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("p", [
          _vm._v(
            " \n            Our regular business hours are Monday to Friday, 8:00 to 16:00 PST (GMT -8).\n            "
          ),
          _c("br"),
          _vm._v(
            "For your convenience, our engineers are available 24 hours a day, 7 days a week for any emergency situation your company may incur.\n        "
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-37e806e0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37e806e0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/Contact.vue
// module id = 471
// module chunks = 0